import { useNavigate } from "react-router-dom";
import { appStorage, getInitials } from "@miplatform/utils";
import { useMsal } from "@azure/msal-react";
import { useProfile } from "@mibuildweb/hooks";

export const useUserMenuController = () => {
  const navigate = useNavigate();
  const { instance } = useMsal();
  const { profile } = useProfile();

  const getUserInitials = () =>
    profile
      ? getInitials(`${profile.firstName} ${profile.lastName}`)
      : undefined;

  const navigateProfile = () => {
    navigate("/profile");
  };

  const navigateLegal = () => {
    navigate("/legal");
  };

  const handleLogout = () => {
    appStorage.clear();
    instance.logoutRedirect();
  };

  return { getUserInitials, navigateLegal, navigateProfile, handleLogout };
};
